module.exports = __webpack_public_path__ + "img/time-28082019.00923530.webp";